/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { userProductLikesSchema } from "./userProductLikesSchema.ts";

export const productsMyLikesListStatus200Schema = z.array(userProductLikesSchema);

export const productsMyLikesListResponseSchema = productsMyLikesListStatus200Schema;
